<template>
  <div
    class="trending-posts-scroll"
    :class="posts.length > 0 ? 'stretch-container' : ''"
  >
    <template v-if="posts.length">
      <div
        class="heading-font flex flex-wrap gap-3 text-lg justify-between items-center sm:border-b sm:pb-2 border-lighter-gray"
      >
        <div>
          <div class="text-lg">Trending<strong>Posts</strong></div>
          <div class="text-sm text-gray">Your awaaz on things that matter.</div>
        </div>
      </div>
      <div
        class="whitespace-nowrap overflow-auto space-x-2 pb-4 mt-4 sm:space-x-6"
      >
        <article
          v-for="post in posts"
          :key="post"
          class="inline-block p-4 max-w-xs w-full bg-white mb-2 rounded"
        >
          <div class="ui-font mb-4 flex flex-wrap gap-1 text-xs md:text-sm">
            <OrbitAuthor
              class="mr-1 h-10 w-10"
              :params="{ style: 'AuthorAvatar', id: post.author }"
              v-if="post.author"
            />
            <div class="text-sm text-gray">
              <OrbitAuthor
                class="mt-1"
                :params="{ style: 'AuthorName', id: post.author }"
                v-if="post.author"
              />
              <div
                class="font-thin text-xs"
                v-html="formatDate(post.date)"
              ></div>
            </div>
          </div>
          <router-link :to="getPostLink(post)">
            <div class="font-bold mb-4 text-lg whitespace-normal h-16">
              <div
                class="heading-font line-clamp-2"
                v-html="post.title.rendered"
              ></div>
            </div>
            <div class="flex gap-2 text-xs text-gray">
              <IconBtn icon="like" />
              <IconBtn icon="comment" />
              <IconBtn icon="share" />
            </div>
          </router-link>
        </article>
      </div>
    </template>
  </div>
</template>
<script>
import Util from "@/lib/Util";
import IconBtn from "@/components/IconBtn.vue";
import OrbitAuthor from "@/lib/OrbitAuthor.vue";

export default {
  name: "TrendingPostScroll",
  props: {
    posts: Array,
    status: String,
  },
  components: {
    IconBtn,
    OrbitAuthor,
  },
  setup() {
    const getPostLink = (post) => Util.getPostLink(post);
    const formatDate = (dateString) => Util.formatDate(dateString);

    return {
      formatDate,
      getPostLink,
    };
  },
};
</script>
<style>
.home-wrapper .term-tabs-wrapper .trending-posts-scroll,
.newsfeed-wrapper .term-tabs-wrapper .trending-posts-scroll {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

@media (min-width: 768px) {
  .home-wrapper .term-tabs-wrapper,
  .newsfeed-wrapper .term-tabs-wrapper {
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }
}

@media (min-width: 1024px) {
  .newsfeed-wrapper .term-tabs-wrapper .trending-posts-scroll {
    margin-left: -3.5rem;
    margin-right: -3.5rem;
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }
}

@media (min-width: 1025px) {
  .home-wrapper .term-tabs-wrapper .trending-posts-scroll {
    margin-left: -0.5rem;
    margin-right: -0.5rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
}
</style>
